/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Cart header badge: hides the item-count number and pulses the badge dot instead,
  // so it doesn't read "2" when a map + an addon (priority/digital/shipping
  // protection) are both in cart — see sections/cfg-cart.liquid for that addon list.
  // Injected here as a <style> tag rather than the theme editor's custom CSS field
  // because that field rejects @keyframes.
  var cartBadgeStyle = document.createElement('style');
  cartBadgeStyle.textContent =
    '.navlink--cart--icon .header__cart__status,' +
    '.navlink--cart--circle .header__cart__status {' +
    '  font-size: 0;right:-3px;min-width:13px;height:13px;' +
    '}' +
    '.navlink--cart--icon .header__cart__status:not([data-cart-count="0"]),' +
    '.navlink--cart--circle .header__cart__status:not([data-cart-count="0"]) {' +
    '  animation: cfgCartDotThrob 1.5s ease-in-out infinite;' +
    '}' +
    '@media only screen and (max-width: 749px) {' +
    '  .navlink--cart--text .header__cart__status { font-size: 0; }' +
    '  .navlink--cart--text .header__cart__status:not([data-cart-count="0"]) {' +
    '    animation: cfgCartDotThrob 1.5s ease-in-out infinite;' +
    '  }' +
    '}' +
    '@keyframes cfgCartDotThrob {' +
    '  0% { transform: scale(0.95); }' +
    '  50% { transform: scale(1.15); }' +
    '  100% { transform: scale(0.95); }' +
    '}' +
    '@media (prefers-reduced-motion: reduce) {' +
    '  .header__cart__status { animation: none !important; }' +
    '}';
  document.head.appendChild(cartBadgeStyle);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
